export default __webpack_public_path__ + "static/media/klipy.a716328d.png";